/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RequestLogInfoDtoV2 {
  id?: number;
  requestId?: string;
  method?: string;
  path?: string;
  queryString?: string | null;
  requestHeaders?: any | null;
  requestBody?: any | null;
  statusCode?: number | null;
  responseHeaders?: any | null;
  responseBody?: any | null;
  startedAt?: string;
  completedAt?: string | null;
  durationMs?: number | null;
  userId?: string | null;
  userEmail?: string | null;
  userRole?: string | null;
  customerEmail?: string | null;
  customerName?: string | null;
  paymentLinkId?: string | null;
  transactionId?: number | null;
  establishmentId?: number | null;
  posId?: string | null;
  clientId?: string | null;
  clientIp?: string | null;
  userAgent?: string | null;
}
